/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Happy_Lark_CookInputs */

const en_gray_happy_lark_cook = /** @type {(inputs: Gray_Happy_Lark_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value calculation`)
};

const de_gray_happy_lark_cook = /** @type {(inputs: Gray_Happy_Lark_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werteberechnung`)
};

/**
* | output |
* | --- |
* | "Value calculation" |
*
* @param {Gray_Happy_Lark_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_happy_lark_cook = /** @type {((inputs?: Gray_Happy_Lark_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Happy_Lark_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_happy_lark_cook(inputs)
	return de_gray_happy_lark_cook(inputs)
});